import { render } from "./LienGroupeInscriptionView.vue?vue&type=template&id=60e08bd1"
import script from "./LienGroupeInscriptionView.vue?vue&type=script&lang=js"
export * from "./LienGroupeInscriptionView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__